import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { ADMIN_ONLY } from "../../constants/Constant";

// Paths that must stay reachable even when the storefront is disabled:
// the admin/supplier areas and the login / password-reset screens.
const ALLOWED_PREFIXES = ["/admin", "/supplier", "/manager/login"];

const isAllowedPath = (pathname) =>
  ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

// A logged-in user is identified the same way the rest of the app does it:
// a truthy "admin" / "supplier" entry in localStorage.
const getLoggedInRedirect = () => {
  if (localStorage.getItem("admin")) return "/admin/orders";
  if (localStorage.getItem("supplier")) return "/supplier/orders";
  return null;
};

// Not logged in: send supplier paths to the supplier login, everything else
// to the manager/admin login.
const getLoginRedirect = (pathname) =>
  pathname === "/supplier" || pathname.startsWith("/supplier/")
    ? "/supplier/login"
    : "/manager/login";

/**
 * When REACT_APP_ADMIN_ONLY is enabled, the public storefront is turned off.
 * Any customer-facing route redirects to the admin area (if logged in) or to
 * the appropriate login screen. When the flag is off this is a no-op wrapper.
 */
const AdminOnlyGuard = ({ children }) => {
  const { pathname } = useLocation();

  if (!ADMIN_ONLY || isAllowedPath(pathname)) {
    return children;
  }

  const target = getLoggedInRedirect() || getLoginRedirect(pathname);
  return <Redirect to={target} />;
};

export default AdminOnlyGuard;
